import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-dark-card" data-id="element-64" data-mp="bjw7e2yctbx8">
      <div className="max-w-6xl mx-auto" data-id="element-65" data-mp="bi1o0t2qdrv9">
        <div className="text-center mb-16" data-id="element-66" data-mp="gbe6elgth2fk">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-67" data-mp="gc5w5fnqg5xx">
            Cosa dicono i docenti che utilizzano Metodologia della Ricerca Pro
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch" data-id="element-68" data-mp="q7pnrpv9kigv">
          {extendedTestimonials.map((t, i) => <motion.figure key={`${t.role}-${i}`} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-black border border-dark-border p-8 rounded-2xl relative flex flex-col h-full ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-69" data-mp="u8j9qdp5bn74" data-mpi={i}>
              <QuoteIcon className="absolute top-6 right-6 text-gold/10" size={48} aria-hidden="true" data-id="element-70" data-mp="33zcdpxowmd5h" />

              <div className="flex gap-1 text-gold mb-6" aria-hidden="true" data-id="element-71" data-mp="3vqifeik9wiwv">
                {[...Array(5)].map((_, j) => <StarIcon key={j} size={16} fill="currentColor" data-id="element-72" data-mp="3rpq7ptr1um2p" data-mpi={j} />)}
              </div>

              <blockquote className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-73" data-mp="3mnr2eebr1f34">
                “{t.text}”
              </blockquote>

              <figcaption className="flex items-center gap-4 mt-auto" data-id="element-74" data-mp="2b9vqdeg55mg4">
                <span className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg shrink-0" data-id="element-75" data-mp="2b82glqa8em3w">
                  {t.initials}
                </span>
                <span data-id="element-76" data-mp="27q52oj7a62uy">
                  <span className="block font-bold text-white" data-id="element-77" data-mp="2cr2hclt30erp">{t.name}</span>
                  <span className="block text-xs text-gold-light" data-id="element-78" data-mp="2coyfe9eqtpu2">{t.role}</span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}